import { configureStore } from '@reduxjs/toolkit';

import authReducer from './features/auth/authSlice';
import flavorsReducer from './features/flavors/flavorsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    flavors: flavorsReducer,
  },
});